module.exports = __webpack_public_path__ + "static/media/texel-logo-simbol.a5403ff9.png";